import React from "react";
import { UnderCostruction } from "../UnderCostruction";

export const ImpostazioniPersonali = () => {
  return <UnderCostruction />;
};
